import { FC } from 'react';
import {
  Icon,
  Menu,
  MenuButton,
  MenuList,
  useBreakpointValue,
  Avatar,
  MenuItem,
  useMediaQuery,
} from '@chakra-ui/react';
import { PilaH, PilaV, Texto } from '../atomos';
import { ChevronDown, LogOut } from 'lucide-react';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { cerrarSesion } from '@/redux/slices/usuarioSlice';
import { useNavigate } from 'react-router-dom';
import { CREDENCIALES } from '@/routes/AppRoutes';

const BotonMenu = () => {
  const { nombre, rut } = useAppSelector((state) => state.usuario);
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const size = useBreakpointValue({ sm: 'md', md: 'sm' });
  return (
    <MenuButton>
      <PilaH spacing={2} p={2}>
        <PilaH spacing={2}>
          <Avatar
            name={nombre}
            size={size}
            background={'bPink.400'}
            color={'layout'}
          />
          {!isMobile ? (
            <PilaV alignItems={'start'} spacing={0}>
              <Texto
                fontSize={'sm'}
                fontWeight={'medium'}
                lineHeight={'shorter'}
              >
                {nombre}
              </Texto>
              <Texto
                fontSize={'sm'}
                lineHeight={'shorter'}
                color={'foreground-secondary'}
              >
                {rut}
              </Texto>
            </PilaV>
          ) : null}
        </PilaH>
        <Icon
          as={ChevronDown}
          boxSize={4}
          color={'compo.300'}
          _groupHover={{ color: 'red' }}
        />
      </PilaH>
    </MenuButton>
  );
};

const MenuOpciones: FC = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const clickCerrarSesion = () => {
    dispatch(cerrarSesion());
    navigate(CREDENCIALES.INICIARSESION, { replace: true });
  };

  return (
    <Menu placement='bottom-end'>
      <BotonMenu />
      <MenuList p={2} display={'flex'} flexDirection={'column'} gap={2}>
        <MenuItem icon={<LogOut size={16} />} onClick={clickCerrarSesion}>
          Cerrar sesion
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default MenuOpciones;
